/**
 * Dragging an asset from the Content Browser to the viewport, as in Unreal.
 * The drag carries the asset's content path under its own data type, and as
 * plain text too: WebKit may deliver only the standard types. Browsers hide a
 * drag's data until the drop, so hovering can only check the types; the drop
 * target then checks the path against the asset catalog, so text dragged in
 * from elsewhere never places anything.
 */

/** The drag data type an asset path travels under. */
export const ASSET_DRAG_TYPE = "application/x-kn-asset";

/** Starts an asset drag: a copy, since the asset stays in the catalog. */
export function startAssetDrag(data: DataTransfer, path: string): void {
  data.effectAllowed = "copy";
  data.setData(ASSET_DRAG_TYPE, path);
  data.setData("text/plain", path);
}

/** Whether a drag in progress may carry an asset (usable during dragover). */
export function isAssetDrag(data: DataTransfer): boolean {
  const types = [...data.types];
  return types.includes(ASSET_DRAG_TYPE) || types.includes("text/plain");
}

/** The dropped asset path candidate, or null (usable on drop; check it against the catalog). */
export function droppedAsset(data: DataTransfer): string | null {
  const path = data.getData(ASSET_DRAG_TYPE) || data.getData("text/plain");
  return path === "" ? null : path;
}
